/* eslint-disable no-case-declarations */
import { GEOFENCING_REQUESTED, GET_GEOFENCING_INFO } from '../../actions/orders/geofencing.actions';

export default function geofencingReducer(state = null, { type, payload }) {
  switch (type) {
    case GEOFENCING_REQUESTED:
      const { selectedCrowns } = state;
      selectedCrowns.push(payload.stopId);

      return {
        ...state,
        selectedCrowns,
      };
    case GET_GEOFENCING_INFO.SUCCESS:
      return {
        stops: payload.data.stops,
      };
    case GET_GEOFENCING_INFO.FAIL:
      return {
        stops: [],
      };
    default:
      return state;
  }
}
